import PermissionStore from './PermissionStore.js'
class User {
	#token = '';
	#local_storage_token_key = 'todo-api-token';
	#uri = '';
	#app;
	#permission_store;
	static #instance;
	constructor() {
		if (User.#instance) {
			return User.#instance
		}

		let token = localStorage.getItem(this.#local_storage_token_key);
		if(token){
			this.#token = token
		}
		this.#permission_store = new PermissionStore(this)
		User.#instance = this;
	}

	getToken()
	{
		return this.#token
	}

	setToken(token)
	{
		this.#token = token
		localStorage.setItem(this.#local_storage_token_key, this.#token);
	}
	getPrevious()
	{
		return this.#uri
	}
	setPrevious(uri)
	{
		this.#uri = uri
	}

	isAuth()
	{
		return this.#token && this.#token.length > 0;
	}

	can(key)
	{
		return this.#permission_store.can(key);
	}


	install(app)
	{
		this.#app = app;
		app.config.globalProperties.$user = this;
	}
	getGlobalProperties()
	{
		return this.#app.config.globalProperties;
	}

	static getInstance() {
		return new User();
	}

	refreshPrivileges()
	{
		this.#permission_store.refreshPrivileges();
	}
	showPermissions()
	{
		return this.#permission_store.showPermissions();
	}
}


export default User